import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import Login from './components/Login';
import AdminDashboard from './components/Admin/AdminDashboard';
import Usuarios from './components/Admin/Usuarios';
import Clientes from './components/Admin/Clientes';
import Reportes from './components/Admin/Reportes';
import ModuloSucursal from './components/Sucursal/ModuloSucursal';
import DashboardAlquila from './components/Alquilacar/DashboardAlquila';

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loggedUser = localStorage.getItem('user');
        if (loggedUser) setUser(JSON.parse(loggedUser));
        setLoading(false);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('user');
        setUser(null);
    };

    if (loading) return <div className="text-center mt-5">Cargando...</div>;

    return (
        <Router>
            <Routes>
                <Route path="/login" element={!user ? <Login setUser={setUser} /> : <Navigate to="/" />} />
                
                {/* RUTAS DE ADMIN */}
                <Route path="/admin" element={user?.rol === 'admin' ? <AdminDashboard logout={handleLogout} /> : <Navigate to="/login" />} />
                <Route path="/admin/usuarios" element={user?.rol === 'admin' ? <Usuarios goBack={() => window.history.back()} /> : <Navigate to="/" />} />
                <Route path="/admin/clientes" element={user?.rol === 'admin' ? <Clientes goBack={() => window.history.back()} /> : <Navigate to="/" />} />
                <Route path="/admin/reportes" element={user?.rol === 'admin' ? <Reportes goBack={() => window.history.back()} /> : <Navigate to="/" />} />

                {/* RUTAS DE SUCURSAL */}
                <Route path="/sucursal/:id" element={user ? <ModuloSucursal user={user} logout={handleLogout} /> : <Navigate to="/login" />} />
                <Route path="/alquilacar" element={user ? <DashboardAlquila user={user} logout={handleLogout} /> : <Navigate to="/login" />} />

                <Route path="/" element={
                    user ? (
                        user.rol === 'admin' ? <Navigate to="/admin" /> :
                        (parseInt(user.sucursal_id) === 4 ? <Navigate to="/alquilacar" /> : <Navigate to={`/sucursal/${user.sucursal_id}`} />)
                    ) : <Navigate to="/login" />
                } />
            </Routes>
        </Router>
    );
}
export default App;